import React from 'react';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';

interface IProps {
  currency: string;
  className?: string;
}

const useStyles = makeStyles((theme) => ({
  container: {
    paddingRight: theme.spacing(),
    color: theme.palette.grey[500],
  },
}));

export const CurrencyAdornment: React.FunctionComponent<IProps> = ({
  currency = 'EUR',
  className,
}: IProps) => {
  const { container } = useStyles();

  return <span className={classNames(container, className)}>{currency}</span>;
};
